module.exports = __webpack_public_path__ + "media/images/it/icons/message-065938c4c4212a3b9d0324509342a649.svg";